module.exports = __webpack_public_path__ + "static/media/shape-3.42fc64ee.png";